import {Route} from "react-router-dom";
import {Suspense} from "react";
import BackdropSpinner from "../components/backdrop-spinner/BackdropSpinner";

const RouteWrapper = ({
                          component: Component,
                          layout: Layout,
                          ...rest
                      }) => {
    return (
        <Route {...rest} render={(props) =>
            <Layout>
                <Suspense fallback={<BackdropSpinner/>}>
                    <Component {...props} />
                </Suspense>
            </Layout>
        }/>
    );
}

export default RouteWrapper;
